import { useRef, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const SELECTED_PERSONA_KEY = "p";
const SELECTED_PERSONA_SESSION_STORAGE_KEY = "memetica-selected-persona";

export function useSelectedPersona() {
  const navigate = useNavigate();
  const location = useLocation();
  const locationRef = useRef(location);
  const searchParams = new URLSearchParams(location.search);

  useEffect(() => {
    locationRef.current = location;
  }, [location]);

  const personaId =
    searchParams.get(SELECTED_PERSONA_KEY) || getLastPersonaId() || "";

  const setPersonaId = (
    personaId: string,
    { replace }: { replace: boolean } = { replace: false }
  ) => {
    const params = new URLSearchParams(locationRef.current.search);
    params.set(SELECTED_PERSONA_KEY, personaId);

    navigate(
      {
        ...locationRef.current,
        search: params.toString(),
      },
      { replace }
    );
    persistLastPersonaId(personaId);
  };

  return [personaId, setPersonaId] as const;
}

function getLastPersonaId() {
  try {
    return sessionStorage.getItem(SELECTED_PERSONA_SESSION_STORAGE_KEY);
  } catch {
    /* Intentionally empty. If we fail to access session storage, there's nothing we can do. */
  }
}

export function persistLastPersonaId(personaId: string) {
  try {
    return sessionStorage.setItem(
      SELECTED_PERSONA_SESSION_STORAGE_KEY,
      personaId
    );
  } catch {
    /* Intentionally empty. If we fail to access session storage, there's nothing we can do. */
  }
}
